/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateBondRunStatusOptions,
  UpdateBondRunStatusResponses,
} from '../types/UpdateBondRunStatus'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update treasury bond run status
 * {@link /v1/assets/:asset_id/bond_run_status}
 */
export function updateBondRunStatus<ThrowOnError extends boolean = true>(
  options: Options<UpdateBondRunStatusOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateBondRunStatusResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/assets/{asset_id}/bond_run_status',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateBondRunStatusResponses, ThrowOnError>>,
  )
}
